import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  public userID = "";
  public action = "";

  GetUser(CompanyId = 0) {
    if (CompanyId == 0) {
      return this.http.get(environment.apiURL + `user/GetUsers?Isactive=true`);
    }
    else {
      return this.http.get(environment.apiURL + `user/GetUsers?CompanyId=` + CompanyId + `&Isactive=true`);
    }
  }
  GetCompany(CompanyId = 0) {
    if (CompanyId == 0) {
      return this.http.get(environment.apiURL + `company/GetCompany?isBAClient=true`);
    }
    else {
      return this.http.get(environment.apiURL + `company/GetCompany?_id=`+CompanyId);
    }
  }
  GetRole(RoleId=0) {
    if (RoleId == 0) {
      return this.http.get(environment.apiURL + `master/GetRole`);
    }
    else {
      return this.http.get(environment.apiURL + `master/GetRole?_id=`+RoleId+`&_id=4`);
    }
  }
  AddUser(data) {
    return this.http.post(environment.apiURL + `user/AddUser`, data);
  }
  GetUserDetails(userID) {
    return this.http.get(environment.apiURL + `user/GetUsers?_id=` + userID);
  }
  UpdateUser(data) {
    return this.http.post(environment.apiURL + `user/UpdateUsers`, data);
  }
  DeleteUser(data) {
    return this.http.post(environment.apiURL + `user/DeleteUser`, data);
  }

  GetUserNotification(data){
    return this.http.post(environment.apiURL + `user/GetUserNotification`, data);
  }

  UpdateUserNotification(data){
    return this.http.post(environment.apiURL + `user/UpdateUserNotification`, data);
  }
}
